import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServicesComponent implements OnInit {

  showProductosDetail = false;
  showSoftwareDetail = false;
  showConstruccionDetail = false;

  constructor(private viewportScroller: ViewportScroller) {}

  public onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }

  toggleProductosDetail(): void {
    this.showSoftwareDetail = false;
    this.showConstruccionDetail = false;
    this.showProductosDetail = !this.showProductosDetail;
  }

  toggleSoftwareDetail(): void {
    this.showProductosDetail = false;
    this.showConstruccionDetail = false;
    this.showSoftwareDetail = !this.showSoftwareDetail;
  }

  toggleConstruccionDetail(): void {
    this.showProductosDetail = false;
    this.showSoftwareDetail = false;
    this.showConstruccionDetail = !this.showConstruccionDetail;
  }

  closeAllDetails(): void {
    this.showProductosDetail = false;
    this.showSoftwareDetail = false;
    this.showConstruccionDetail = false;
  }

  closeProductosDetail(): void {
    this.showProductosDetail = false;
  }

  /** Oculta las cajas madres de Servicios (solo Software / Construcción) */
  get servicesMothersHidden(): boolean {
    return this.showSoftwareDetail || this.showConstruccionDetail;
  }

  get anyDetailOpen(): boolean {
    return this.servicesMothersHidden;
  }

  ngOnInit() {
  }

}
